	<ibis-user [allowEdit]='true'></ibis-user>